import { render, staticRenderFns } from "./promoCode.vue?vue&type=template&id=04a08487&"
import script from "./promoCode.vue?vue&type=script&lang=js&"
export * from "./promoCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports